import { useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import axios from "axios";
import LanguageTranslations from "@i18n/types";
import { useDispatch } from "react-redux";
import { setTranslationKeys } from "@redux/slices/translationSlice";
import { DataRefreshInfo } from "@src/types/dataRefreshInfo";
import { setNavMenuKeys } from "@redux/slices/navMenuSlice";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import Constants from "expo-constants";
import { ThemeTokenTypes } from "@scenes/splash-screen/types";
import { setOrgTranslationKeys } from "@redux/slices/appStateSlice";

export const useConfig = () =>
  useQuery({
    queryKey: ["CONFIG"],
    queryFn: () => apiClient.get(Routes.CONFIG),
  });

export const useLoadTranslations = (
  url: string,
  enabled: boolean,
  type?: string
) => {
  const dispatch = useDispatch();
  const timestamp = Date.now();

  return useQuery({
    queryKey: ["LOAD_TRANSLATIONS", url],
    cacheTime: 86400000,
    enabled: enabled,
    queryFn: () =>
      axios
        .get<LanguageTranslations>(url + "?timestamp=" + timestamp)
        .then((data) => {
          if (type === ThemeTokenTypes.ORG) {
            dispatch(setOrgTranslationKeys(data.data));
          }
          dispatch(setTranslationKeys(data.data));
          return data;
        }),
  });
};

export const useLoadNavMenu = (enabled: boolean) => {
  const dispatch = useDispatch();
  const timestamp = Date.now();

  return useQuery({
    queryKey: ["LOAD_NAV_MENU"],
    cacheTime: 86400000,
    enabled,
    queryFn: () =>
      axios.get(Routes.NAV_MENU + "?timestamp=" + timestamp).then((data) => {
        dispatch(setNavMenuKeys(data.data));
        return data;
      }),
  });
};

// export const useDataRefreshInfo = () =>
//   useQuery({
//     queryKey: ["DATA_REFRESH_INFO"],
//     queryFn: () =>
//       apiClient.get<DataRefreshInfo>(Routes.DATA_REFRESH_INFO, {
//         headers: {
//           ...apiClient.defaults.headers.common,
//           "If-None-Match": "",
//         },
//       }),
//   });

export const useDataRefreshInfo = () => {
  const userInfo = useUserInfo();
  const timestamp = Date.now();

  interface Params {
    config_version: number;
    user_id?: number;
  }

  return useQuery({
    queryKey: ["DATA_REFRESH_INFO"],
    cacheTime: 0,
    queryFn: () => {
      const userId = userInfo.getUserId();
      const params: Params = {
        config_version: process.env.EXPO_PUBLIC_APP_CONFIG_VERSION
          ? process.env.EXPO_PUBLIC_APP_CONFIG_VERSION
          : Constants?.expoConfig?.extra?.appConfigVersion,
      };
      if (userId) {
        params.user_id = userId;
      }

      return apiClient.get<DataRefreshInfo>(
        Routes.DATA_REFRESH_INFO + "?timestamp=" + timestamp,
        {
          headers: {
            ...apiClient.defaults.headers.common,
            "If-None-Match": "",
          },
          params,
        }
      );
    },
  });
};

export const useWebUpdatesCheck = (enabled: boolean) => {
  const timestamp = Date.now();
  return useQuery({
    queryKey: ["WEB_UPDATES_CHECK"],
    cacheTime: 0,
    enabled,
    queryFn: () =>
      axios
        .get(Routes.WEB_UPDATES_CHECK + "?timestamp=" + timestamp)
        .then((data) => {
          return data;
        }),
  });
};
